// Everything in the app is scoped to the selected product. This module holds
// the current product id for the API client and for browser storage, so
// screens don't need to pass it around.
let currentProductId = '';

export const getCurrentProductId = () => currentProductId;
export const setCurrentProductId = (id) => {
    currentProductId = id || '';
};

// localStorage keys the screens use; each product gets its own copy
export const SCOPED_KEYS = ['planPreferences', 'planView', 'planAutomationsOpen', 'selectedHooks', 'imageDescription', 'videoEntries', 'createFlow'];

const scopedKey = (key) => (currentProductId ? `${key}:${currentProductId}` : key);

export const storage = {
    get(key) {
        try {
            return localStorage.getItem(scopedKey(key));
        } catch (e) {
            return null;
        }
    },
    set(key, value) {
        try {
            localStorage.setItem(scopedKey(key), value);
        } catch (e) {
            // Storage unavailable; the value still works for this session
        }
    },
    getJson(key, fallback) {
        try {
            const value = JSON.parse(this.get(key));
            return value ?? fallback;
        } catch (e) {
            return fallback;
        }
    },
    setJson(key, value) {
        this.set(key, JSON.stringify(value));
    },
};

// The first product takes over data saved before products existed
export const adoptLegacyStorage = (productId) => {
    try {
        SCOPED_KEYS.forEach(key => {
            const legacy = localStorage.getItem(key);
            if (legacy != null && localStorage.getItem(`${key}:${productId}`) == null) {
                localStorage.setItem(`${key}:${productId}`, legacy);
            }
        });
    } catch (e) {
        // Storage unavailable; nothing to adopt
    }
};

export const removeProductStorage = (productId) => {
    try {
        SCOPED_KEYS.forEach(key => localStorage.removeItem(`${key}:${productId}`));
    } catch (e) {
        // Storage unavailable
    }
};
